import { formatAgents } from './format-agents';
import { formatBankDetails } from './format-bank-details';
import { formatBusinessDocuments } from './format-business-documents';
import { formatBusinessInfo } from './format-business-info';
import { formatHeadOfficeAddress } from './format-head-office-address';
import { formatPointsOfSales } from './format-points-of-sales';
import { formatRegisteredAddress } from './format-registered-address';

import {
  ApplicationFormValues,
  SectionName,
  sectionNames,
  ApplicationData,
  CreatePartnerApplicationRequest,
  PartnerApplicationContext,
} from '../../model';

type ApplicationDataFormatterMap = {
  [K in Exclude<SectionName, 'ownership'>]: (
    data: ApplicationData,
    values: Partial<ApplicationFormValues>[K]
  ) => ApplicationData;
};

const applicationDataFormatters = {
  [sectionNames.businessInfo]: formatBusinessInfo,
  [sectionNames.registeredAddress]: formatRegisteredAddress,
  [sectionNames.headOfficeAddress]: formatHeadOfficeAddress,
  [sectionNames.businessDocuments]: formatBusinessDocuments,
  [sectionNames.bankDetails]: formatBankDetails,
  [sectionNames.pointsOfSales]: formatPointsOfSales,
  [sectionNames.agents]: formatAgents,
} satisfies ApplicationDataFormatterMap;

export function mapPartnerApplicationContextToApplicationData(
  context: PartnerApplicationContext
): ApplicationData {
  let data: ApplicationData = {};
  const names = Object.keys(applicationDataFormatters) as Array<
    keyof typeof applicationDataFormatters
  >;

  for (const name of names) {
    data = applicationDataFormatters[name](data, context[name] as any);
  }

  return data;
}

type CreateApplicationDataFormatterMap = {
  [K in Extract<SectionName, 'businessInfo'>]: (
    data: ApplicationData,
    values: Partial<ApplicationFormValues>[K]
  ) => ApplicationData;
};

const createApplicationDataFormatters = {
  [sectionNames.businessInfo]: formatBusinessInfo,
} satisfies CreateApplicationDataFormatterMap;

export function mapPartnerApplicationContextToCreateApplicationData(
  context: PartnerApplicationContext
): CreatePartnerApplicationRequest | null {
  let data: ApplicationData = {};

  const names = Object.keys(createApplicationDataFormatters) as Array<
    keyof typeof applicationDataFormatters
  >;

  for (const name of names) {
    data = applicationDataFormatters[name](data, context[name] as any);
  }

  if (!context.ownership || !data.businessInfo) {
    return null;
  }

  return {
    ownership: context.ownership,
    businessInfo: data.businessInfo,
    deviceData: {},
  };
}
